export function checkDev() {
	return process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
}

export const env = {
	dev: 'dev',
	prod: 'prod',
	uat: 'uat',
	staging: 'staging',
};

export const getEnv = () => {
	if (window.location.hostname === 'doraemon.clocksea.com') {
		return env.prod;
	} else if (window.location.hostname === 'doraemon.funkytest.com') {
		return env.uat;
	} else if (window.location.hostname === 'doraemon-stg.funkytest.com') {
		return env.staging;
	}
	return env.prod;
};

export const gcpCdn = 'wcq5hjvjnqxirkm3.copiousplus.com';
export const imgEnvHost = `https://${gcpCdn}/${getEnv()}/`;
